var window=global;var $CLJS=require("./cljs_env.js");
'use strict';$CLJS.UI=require("moment");module.exports=$CLJS.UI;